// extracted by mini-css-extract-plugin
export var copyIcon = "_z6-2";
export var discountCard = "_z6-0";
export var discountCode = "_z6-3";
export var discountContent = "_z6-1";
export var loadingCard = "_z6-4";